import React from 'react';
import './Contact.css';
import { AppModal } from '../Modals/TextAreaModal';
import { ContactBox } from './ContactBox.js';
import img from './ContactMedia/img.jpg';
import FadeIn from 'react-fade-in';



class Contact extends React.Component {
  constructor(props){
    super(props);

 

    //State storage - should be hooked up with mongoose
   
   //We use OnLoadPost to get latest stored DB post. Intended to use with cancel button.
    this.state =  {
      title: "Kontakt oss",
      post: '<b><h2>Om GAMERLAN</h2></b><br> GAMERLAN ble etablert i 2008, og startet på "Blinken" i Mysen. <br> Den gangen hadde vi noen få deltakere. <br> Mye har skjedd siden da. Nå holder vi til på Eidsberg ungdomskole, og arrangerer LAN to ganger i året. <br> Antall deltakere har gått opp, og vi ligger nå på et snitt på 70 stykker. <br> <br> <br> I 2018 feiret vi 10 år, og vi setter utrolig pris på alle som kommer tilbake, år etter år. <br> Vi håper på mange flere høst og vinterferier med LAN! <br> <br> Vi i crew som arrangerer LANet jobber frivillig, og tar fri fra jobb for å sette opp bord, rigge nettverk, og gjøre klart til moro.  <br> <br> <h6> Nettsiden er laget av Clemet Wengen og Magnus Myklatun  <br> <br> <br> Org.nr: 913552806 <br> </h6> ',
      onLoadPost: '<b><h4>Om GAMERLAN</h4></b><br> GAMERLAN ble etablert i 2008, og startet på "Blinken" i Mysen. <br> Den gangen hadde vi noen få deltakere. <br> Mye har skjedd siden da. Nå holder vi til på Eidsberg ungdomskole, og arrangerer LAN to ganger i året. <br> Antall deltakere har gått opp, og vi ligger nå på et snitt på 70 stykker. <br><br> I 2018 feiret vi 10 år, og vi setter utrolig pris på alle som kommer tilbake, år etter år. <br> Vi håper på mange flere høst og vinterferier med LAN! <br> <br> Vi i crew som arrangerer LANet jobber frivillig, og tar fri fra jobb for å sette opp bord, rigge nettverk, og gjøre klart til moro.  <br> <br> <h6> Nettsiden er laget av Clemet Wengen og Magnus Myklatun  <br> <br> <br> Org.nr: 913552806 <br>  </h6>',
      
      showModal: false,
      auth: false
    };

    
  //Bindings
    this.changePost = this.changePost.bind(this);  
    this.cancelPost = this.cancelPost.bind(this);
    this.savePost = this.savePost.bind(this);
    this.modalPop = this.modalPop.bind(this);
  }

  componentDidMount(){
    window.scrollTo(0, 0);
  }


  changePost(newPost){ //Takes an event param, done automatically by eventhandler - see AppModal for handleChange
    this.setState({post: newPost });  //Updates the state with new value
  }

  //Event for modal cancel button, sets Post state back to onLoadPost
  cancelPost(cancel)
  {
    this.setState({post: this.state.onLoadPost});
    this.setState({showModal: false});
  }
  //Event for modal save button, will push to DB, needs logic implementation
  savePost(newPost){ //Implement logic for saving post and refreshing the content
    console.log("saved the post");
    this.setState({onLoadPost: newPost});
  }

  modalPop(e){ //Trigger App's modal component... Toggles showModal true or false
    if (this.state.showModal === false)
    {
    this.setState({showModal: true})
    }
    else{
      this.setState({showModal: false})
    }
  }





  render() {
    return (
      <FadeIn>
      <div className="Contact">
        

        <div className="row about">
        <div className="col-md-9 col-centered" >
              
        <div className="card">
        <div className="Post"  dangerouslySetInnerHTML={{ __html: this.state.post }}>
        </div>
        
       

    </div>
    {this.state.auth === true &&<button  className="btn btno btn-info" onClick={this.modalPop}> Modal </button>}
    </div>
   
        </div>

         <div className="imgWrapper"> <div className="img" style={{backgroundImage:"url(" + img + ")"}}></div> </div>
        
        
        {this.state.showModal === true && <AppModal post={this.state.post} onLoadPost={this.state.onLoadPost} onChange={this.changePost} cancelPost={this.cancelPost} savePost={this.savePost} showModal={this.state.showModal} /> } 
      
        <ContactBox auth={this.state.auth}/>


      </div>
      </FadeIn>
    );
  }
}


export default Contact;



// WEBPACK FOOTER //
// ./src/Components/Contact/Contact.js